import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px',
    animation: '$fadeIn 0.3s ease-out',
  },
  overlayClosing: {
    animation: '$fadeOut 0.3s ease-in forwards',
  },
  modal: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    width: 'calc(100vw - 400px)',
    maxWidth: '900px',
    height: 'calc(100vh - 140px)',
    maxHeight: '800px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
    position: 'relative',
    left: '140px',
    overflow: 'hidden',
    marginTop: '40px',
    animation: '$slideUp 0.3s ease-out',
  },
  modalClosing: {
    animation: '$slideDown 0.3s ease-in forwards',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    borderBottom: '2px solid #e0e0e0',
    flexShrink: 0,
    backgroundColor: '#fafafa',
  },
  title: {
    margin: 0,
    color: '#1a1a1a',
    fontSize: '18px',
    fontWeight: 600,
  },
  closeButton: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2rem',
    height: '2rem',
    background: 'none',
    border: 'none',
    borderRadius: '4px',
    color: 'rgba(255,255,255,0.7)',
    transition: 'all 0.15s',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.2)',
      color: '#fff',
    },
  },
  toolbar: {
    padding: '8px 16px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
    borderBottom: '1px solid #e8e8e8',
    backgroundColor: '#f5f5f5',
    flexShrink: 0,
  },
  toolbarBtn: {
    padding: '5px 12px',
    border: '1px solid #d0d0d0',
    borderRadius: '4px',
    backgroundColor: '#fff',
    color: '#555',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 500,
    transition: 'all 0.15s',
    '&:hover': {
      backgroundColor: '#e8e8e8',
      color: '#222',
      borderColor: '#bbb',
    },
  },
  copyButton: {
    padding: '5px 12px',
    border: '1px solid #b8d4f0',
    borderRadius: '4px',
    backgroundColor: '#eaf3fc',
    color: '#2563eb',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 500,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    transition: 'all 0.15s',
    '&:hover': {
      backgroundColor: '#d4e6f9',
      borderColor: '#93bde6',
    },
  },
  xmlContainer: {
    overflow: 'hidden',
    flex: 1,
    fontSize: '13px',
    fontFamily:
      '"SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
    lineHeight: '1.6',
    color: '#1a1a1a',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  contentArea: {
    overflow: 'auto',
    flex: 1,
    padding: '4px 0',
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    minHeight: '26px',
    transition: 'background-color 0.1s',
    '&:hover': {
      backgroundColor: '#f0f4ff !important',
    },
  },
  rowHighlighted: {
    backgroundColor: '#fff8e1 !important',
  },
  lineNumber: {
    width: '44px',
    minWidth: '44px',
    textAlign: 'right',
    paddingRight: '12px',
    color: '#b0b0b0',
    fontSize: '12px',
    lineHeight: '26px',
    userSelect: 'none',
    borderRight: '1px solid #eee',
    marginRight: '12px',
    flexShrink: 0,
  },
  xmlDeclaration: {
    color: '#7c8da0',
    fontStyle: 'italic',
    lineHeight: '26px',
  },
  nodeText: {
    color: '#1a7f37',
    display: 'inline-block',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    lineHeight: '26px',
  },
  nodeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    lineHeight: '26px',
  },
  collapseIcon: {
    cursor: 'pointer',
    marginRight: '6px',
    userSelect: 'none',
    color: '#2563eb',
    fontSize: '9px',
    lineHeight: '26px',
    width: '16px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: '3px',
    transition: 'all 0.15s',
    '&:hover': {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8',
    },
  },
  collapseIconPlaceholder: {
    width: '16px',
    marginRight: '6px',
    flexShrink: 0,
    display: 'inline-block',
  },
  collapsedBadge: {
    display: 'inline-block',
    marginLeft: '8px',
    padding: '0 8px',
    borderRadius: '10px',
    backgroundColor: '#eef2ff',
    color: '#4f46e5',
    fontSize: '11px',
    lineHeight: '20px',
    cursor: 'pointer',
    fontWeight: 500,
    border: '1px solid #e0e7ff',
    transition: 'all 0.15s',
    '&:hover': {
      backgroundColor: '#e0e7ff',
    },
  },
  nodeTag: {
    cursor: 'pointer',
    borderRadius: '3px',
    padding: '0 2px',
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  // Shared colors used by both XML and JSON
  tagBracket: {
    color: '#6e7781',
  },
  tagName: {
    color: '#cf222e',
    fontWeight: 600,
  },
  attrName: {
    color: '#8250df',
  },
  attrQuote: {
    color: '#6e7781',
  },
  attrValue: {
    color: '#0a3069',
  },
  // JSON-specific
  jsonColon: {
    color: '#6e7781',
    fontWeight: 500,
  },
  jsonComma: {
    color: '#6e7781',
  },
  jsonBracket: {
    color: '#e16f24',
    fontWeight: 600,
  },
  jsonNumber: {
    color: '#0550ae',
    fontWeight: 500,
  },
  jsonNull: {
    color: '#999',
    fontStyle: 'italic',
  },
  jsonPre: {
    margin: 0,
    padding: '12px 16px',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    color: '#1a1a1a',
  },
  '@keyframes slideUp': {
    from: { transform: 'translateY(100%)' },
    to: { transform: 'translateY(0)' },
  },
  '@keyframes slideDown': {
    from: { transform: 'translateY(0)' },
    to: { transform: 'translateY(100%)' },
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  '@keyframes fadeOut': {
    from: { opacity: 1 },
    to: { opacity: 0 },
  },
});

export default useStyles;
